import React from "react"
import { Link } from "gatsby"
import "./navigation.scss"

const Navigation = () => {
  return (
    <nav>
      <Link to="/feedback">
        <h4>ОТЗЫВЫ</h4>
      </Link>
      <Link to="/contacts">
        <h4>КОНТАКТЫ</h4>
      </Link>
    </nav>
  )
}
export default Navigation
